<div class="testimonial" id="testimonial">
  <p class="testimonial__quote display-quote">
    {{ testimonialConfig().quote }}
  </p>
  <div class="testimonial__author d-flex">
    <img
      class="testimonial__author-img"
      [ngSrc]="'../../assets/img/' + testimonialConfig().imgUrl"
      width="52"
      height="52"
      [alt]="testimonialConfig().altDescription"
    />
    <p class="testimonial__author-person m-0">
      {{ testimonialConfig().namePosition }}
    </p>
  </div>
</div>
